import {ClientConfig} from './client-config.token';
import {environment} from '@env/environment';
import {BufferedMessageService} from '@shared/services/buffered-message.service';

declare global {
  interface Window {
    __env?: ClientConfig;
  }
}

export function createClientConfig(bufferedMessageService: BufferedMessageService): ClientConfig {
  if (window.__env) {
    console.log('Config loaded from window.__env:', window.__env.clientId);
    validateConfigStructure(bufferedMessageService);

    return window.__env;
  }

  if (environment.production) {
    console.error('window.__env not found!');
    bufferedMessageService.add({
      severity: 'error',
      summary: 'CRITICAL: Configuration Not Loaded',
      detail: 'Client configuration file (config.js) is missing. Application cannot operate. Contact administrator.',
      sticky: true,
      life: 20_000
    });

    return {
      clientId: 'MISSING_CONFIG',
      clientName: 'Configuration Error',
      baseUrl: 'https://config-error.invalid',
      baseApiUrl: 'https://config-error.invalid/api/',
      baseWsUrl: 'wss://config-error.invalid/',
      imageUrl: 'https://config-error.invalid',
      linkUrl: 'https://config-error.invalid/',
    };
  }

  console.warn('window.__env not found, using environment defaults');
  bufferedMessageService.add({
    severity: 'warn',
    summary: 'Development Mode',
    detail: 'Using fallback configuration',
    life: 5_000
  });

  return environment.defaultConfig;
}

function validateConfigStructure(bufferedMessageService: BufferedMessageService): void {
  const config = window.__env;

  const required: (keyof ClientConfig)[] = [
    'clientId', 'clientName', 'baseUrl',
    'baseApiUrl', 'baseWsUrl', 'imageUrl', 'linkUrl'
  ];

  const missing = required.filter(field => !config[field]);

  if (missing.length > 0) {
    console.log('Config is missing required fields: ', missing.join(', '));
    bufferedMessageService.add({
      severity: 'error',
      summary: 'Configuration Incomplete',
      detail: `Missing required fields: ${missing.join(', ')}`,
      sticky: true,
      life: 15_000
    });
    return;
  }
}

